<template>
	<div class="servicosDetalhes">
		<section>
			<div class="container">
				<div class="row">
					<grupo-categoria @filterCategoria="filterCategoria"></grupo-categoria>
					
					<div class="col-sm-9 padding-right">
						<div class="product-details"><!--product-details-->
							<div class="col-sm-5">
								<div class="view-product">
									<img :src="produto.imagens[0]" alt="" />
								</div>
								

							</div>
							<div class="col-sm-7">
								<div class="product-information"><!--/product-information-->
									<!-- <img src="images/product-details/new.jpg" class="newarrival" alt="" /> -->
									<h2>{{produto.nome}}</h2>
									<p v-if="produto.descricao">{{produto.descricao}}</p>									
									<span>
										<router-link to="/contato"><span>Consulte nossos preços</span></router-link>
									</span>
									<p><b>Categoria: </b>{{categoriaNome}}</p>
									<!-- <a href=""><img src="images/product-details/share.png" class="share img-responsive"  alt="" /></a> -->
								</div><!--/product-information-->
							</div>
							<div class="col-sm-12" style="margin-top: 60px"><h3>Imagens do Produto</h3></div>
							<div id="similar-product" class="col-sm-12 carousel slide" data-ride="carousel">
									
								<carousel :per-page="1" :navigate-to="someLocalProperty" :navigationEnabled="true" :autoplay="true" :loop="true" :autoplay-timeout="3000" :pagination-padding="2" >
									<slide v-for="img in produto.imagens">
										<img :src="img" alt="" class="imgBannerProd" >
									</slide>
								</carousel>
							</div>
						</div><!--/product-details-->
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import GrupoCategoria from '../components/Categorias.vue';
import firebase from 'firebase';

export default {
    name: 'DetalhesServico',
    components: {
		GrupoCategoria
    },
    data() {
        return {
            produto: {
                nome: '',
				categoria: '',
				imagens: [],
				descricao: ''
            }
        }
    },
    created() {
        var cat = firebase.database().ref(`produtos/${this.$route.params.id}`)
        cat.on('child_added', (data) => {
            if(data.key == 'nome') this.produto.nome = data.val()
            if(data.key == 'categoria') this.produto.categoria = data.val()
			if(data.key == 'imagens') this.produto.imagens = data.val()
			if(data.key == 'descricao') this.produto.descricao = data.val()
        });
    },
    methods: {
        filterCategoria(id) {
            this.$router.push({ name: 'Servicos', params: { categoria: id }})
        }
    },
    computed: {
        categoriaNome () {
            let categoriaNome;
            var cat = firebase.database().ref(`categorias/${this.produto.categoria}`)
            cat.on('child_added', (data) => {
                if(data.key == 'nome')  categoriaNome = data.val()
            });
            return categoriaNome
        }
    }
}
</script>
<style>
.imgBannerProd{
	height: 100%;
}

.servicosDetalhes {
	padding-top: 10px
}
</style>
